import { Skeleton } from 'antd';

import { Box } from '@frontend/components';

const Container = ({ children }) => (
  <Box display="flex" margin={1} width="100%">
    {children}
  </Box>
);

const Column = ({ children }) => (
  <Box display="flex" flexBasis="50%" flexDirection="column" marginRight={0.5}>
    {children}
  </Box>
);

const Searching = () => (
  <Container>
    <Column>
      <Skeleton active={true} paragraph={{ rows: 8 }} />
    </Column>
    <Column>
      <Skeleton active={true} paragraph={{ rows: 8 }} />
    </Column>
  </Container>
);

export default Searching;
